import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { toSPKI as exportPublic } from '../runtime/asn1.js';
import { toPKCS8 as exportPrivate } from '../runtime/asn1.js';
import keyToJWK from '../runtime/key_to_jwk.js';
export function exportSPKI(_x) {
  return _exportSPKI.apply(this, arguments);
}

function _exportSPKI() {
  _exportSPKI = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(key) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", exportPublic(key));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _exportSPKI.apply(this, arguments);
}

export function exportPKCS8(_x2) {
  return _exportPKCS.apply(this, arguments);
}

function _exportPKCS() {
  _exportPKCS = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(key) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", exportPrivate(key));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _exportPKCS.apply(this, arguments);
}

export function exportJWK(_x3) {
  return _exportJWK.apply(this, arguments);
}

function _exportJWK() {
  _exportJWK = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(key) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", keyToJWK(key));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _exportJWK.apply(this, arguments);
}